// Centralized brand info & assets
export const BRAND = {
  name: "Qamar Al Zahran",
  tagline: "Roastery — Dry Fruits, Nuts, Chocolates",
  phone: "+971 56 925 2703",
  phoneDigits: "971569252703",
  email: "qamaralzaharan@gmail.com",
  instagram: "Qamar_al_zahran",
  instagramUrl: "https://instagram.com/Qamar_al_zahran",
  hours: "Monday – Sunday  ·  8:30 AM – 12:00 AM",
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_qamar-gourmet/artifacts/2w8rwli7_WhatsApp%20Image%202026-06-09%20at%205.53.31%20PM.jpeg",
  storefront:
    "https://customer-assets.emergentagent.com/job_qamar-gourmet/artifacts/v3x450as_WhatsApp%20Image%202026-06-08%20at%205.10.18%20PM.jpeg",
  interiorStaff:
    "https://customer-assets.emergentagent.com/job_qamar-gourmet/artifacts/igmank0z_WhatsApp%20Image%202026-06-08%20at%205.10.17%20PM%20%281%29.jpeg",
  interiorShelves:
    "https://customer-assets.emergentagent.com/job_qamar-gourmet/artifacts/sg8ecr9d_WhatsApp%20Image%202026-06-08%20at%205.16.46%20PM%20%281%29.jpeg",
  giftBox:
    "https://images.unsplash.com/photo-1674620213535-9b2a2553ef40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  giftBox2:
    "https://images.unsplash.com/photo-1592903297149-37fb25202dfa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  nutsCategory:
    "https://images.unsplash.com/photo-1704079662049-d00890d21a69?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  chocolateCategory:
    "https://images.unsplash.com/photo-1511381939415-e44015466834?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dryFruitsCategory:
    "https://images.pexels.com/photos/1132047/pexels-photo-1132047.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const buildWhatsAppLink = (message = "") => {
  const base = `https://wa.me/${BRAND.phoneDigits}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};

export const productInquiryMessage = (productName) =>
  `Hello Qamar Al Zahran! I'd like to order:\n• ${productName}\n\nCould you please share availability and price?`;
